import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TenantOverview from './TenantOverview';
import TenantDetails from './TenantDetails';
import AddTenant from './AddTenant';

export default function Users({ match }) {
  return (
    <Switch>
      <Route path={match.path} component={TenantOverview} exact />
      <Route path={`${match.path}/edit/:email`} component={TenantDetails} />
      <Route path={`${match.path}/create`} component={AddTenant} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/auth/Tenants.jsx